import { StoreExt } from '@utils/reactExt'
import { action } from 'mobx'
import { homeStoreG } from '@src/containers/viewsG/home/actor/store'
import { encrypt } from '@utils/aes.js'

class LoginStoreG extends StoreExt {

    @action
    handleLogin = async (email, passwd, fromReg?) => {
        this.showLoading()
        try {
            await this.api.loginByUser({
                username: email,
                password: fromReg ? passwd : await encrypt(passwd),
            })
            await this.bindIccid()
            const res = await homeStoreG.getUserInfo()
            if (!res.iccid) {
                this.replacePath('/global/bind-simCard')
                return
            }
            this.replacePath('/global/home')
        } catch (e) { } finally {
            this.hideLoading()
        }
    }

    @action
    bindIccid = async () => {
        try {
            const url = location.href.split('?iccid=')[1]
            const iccid = url.split('&')[0]
            if (iccid) {
                await this.api.bindIccid({ iccid })
            }
        } catch (e) { }
    }
}

const loginStoreG = new LoginStoreG()
export { loginStoreG, LoginStoreG }
